import { atom } from "jotai";

const studentLoggedIn = atom<boolean>(false);

const providerLoggedIn = atom<boolean>(false);

export { studentLoggedIn, providerLoggedIn };